import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { CUSTOM_USER_FEATURE, CustomUserState, StateWithCustomUser } from '../user-state';

export const getCustomUserState: MemoizedSelector<StateWithCustomUser, CustomUserState> =
  createFeatureSelector<CustomUserState>(CUSTOM_USER_FEATURE);
